export interface IonIntlTelInputModel {
  internationalNumber?: string;
  nationalNumber?: string;
  e164Number?: string;
  dialCode?: string;
  countryCode?: string;
  isoCode?: string;
}
